module.exports = __webpack_public_path__ + "img/contactTask.0ae133c7.png";